import React from "react";
import { showPopupModal } from "@widgets/CommonModal";
import SysPwdPopup from "@widgets/commonpopup/SysPwdPopup";
import SYS_ADDINFO_POP_01 from "@widgets/commonpopup/sys/SYS_ADDINFO_POP_01";

type OpenAddInfoPopupParams = {
  // 메뉴 코드
  cd_menu: string;
  // 대상 영역(grid1, grid2, form1...)
  id_target: string;
  // 대상/표시항목 구성에 사용할 컬럼 메타(필수)
  columnInfos: any[];
};

// 부가항목 설정 팝업 오프너
// - 보안 비밀번호 확인 후 설정 팝업을 연다.
// - columnInfos는 반드시 전달되어야 하며 설정 팝업에서 표시항목 선택에 사용된다.
export const openAddInfoPopup = async ({
  cd_menu,
  id_target,
  columnInfos,
}: OpenAddInfoPopupParams): Promise<boolean> => {
  const pwdComponent = <SysPwdPopup />;
  const pwdResult = await showPopupModal({
    title: "SYSTEM 비밀번호를 입력해주세요",
    children: pwdComponent,
    width: "390px",
    height: "210px",
    checkData: false,
  });
  if (!pwdResult || pwdResult === "close") return false;

  const addInfoComponent = (
    <SYS_ADDINFO_POP_01
      cd_menu={cd_menu}
      id_target={id_target}
      columnInfos={columnInfos}
    />
  );

  const result = await showPopupModal({
    title: "부가항목 설정",
    children: addInfoComponent,
    width: "70%",
    height: "80%",
  });

  return !!(result && result !== "close");
};
